import React, { useState, useEffect } from "react"
import useSound from "use-sound"
import { playTokenBet, getBets, getTokenBalance } from "../redux/tokenAction"
import { TOKENS } from "../constants/constants"
import LoadingOverlay from "react-loading-overlay"
import RecentPlays from "./RecentPlays"
import FAQ from "./FAQ"
import Multipliers from './common/Multipliers'
import Amounts from './common/Amounts'
import { setBetAmount, setBetMultiplier, setLoading, setRecentBets, setShowFaq, setToken, setAccordionActiveKey, setTokenBalances } from "../redux/reducers/storageSlice"
import { Container, Row, Col, Button, Dropdown, ButtonGroup } from "react-bootstrap"
import { useAppSelector, useAppDispatch } from "../hooks"
import Mixpanel from "mixpanel"
import TokenSelect from './TokenSelect';
import { isMobile, osName } from "react-device-detect"
import { WalletModalProvider, WalletMultiButton } from "@solana/wallet-adapter-react-ui"
import { useWallet } from "@solana/wallet-adapter-react"
import axios from "axios"
import winSound from "../sounds/Win.mp3"
import lossSound from "../sounds/Loss.mp3"

LoadingOverlay.propTypes = undefined

const Token: React.FC = () => {
    const dispatch = useAppDispatch()
    const [playWin] = useSound(winSound)
    const [playLoss] = useSound(lossSound)
    const solBalance = useAppSelector((state) => state.storage.solBalance)
    const selectedToken = useAppSelector((state) => state.storage.token)
    const [playerDetails, setPlayerDetails] = useState({
        country: "none",
        OS: "none",
    })
    const [gameState, setGameState] = useState("not playing")
    const [subMsgs, setSubMsgs] = useState([])
    const [loaderActive, setLoaderActive] = useState(false)
    const [loaderImage, setLoaderImage] = useState("images/trident1.gif")
    const [loaderMsg, setLoaderMsg] = useState("")
    const [currentTokenBalance, setCurrentTokenBalance] = useState(0)
    const sound = useAppSelector((state) => state.storage.sound)
    const betMultiplier = useAppSelector((state) => state.storage.betMultiplier)
    const betAmount = useAppSelector((state) => state.storage.betAmount)
    const walletConnected = useAppSelector((state) => state.storage.wallet)
    const tokenBalances = useAppSelector((state) => state.storage.tokenBalances)
    const mode = useAppSelector(state => state.storage.mode)
    const mixpanel = Mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN_ID)
    const wallet = useWallet()

    const getGeoInfo = () => {
        // console.log("BROWSER", isBrowser)
        axios
            .get("https://ipapi.co/json/")
            .then((response) => {
                let data = response.data
                console.log(data)
                setPlayerDetails({
                    country: data.country_name,
                    mobile: isMobile,
                    OS: osName,
                })
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const getRecentBets = async () => {
        const data = await getBets(null, selectedToken)
        // console.log(data)
        dispatch(setRecentBets(data))
    }
    const getSelectedTokenBalance = async () => {
        let tokenBal = await getTokenBalance(selectedToken, wallet)
        console.log(tokenBal)
        setCurrentTokenBalance(tokenBal)
    }

    const getTokenBalances = async () => {
        let tokens = Object.keys(TOKENS)
        let dispatchedTokenBalances = {}
        for (var i = 0; i < tokens.length; i++){
            let curToken = tokens[i]
            let tokenBal = await getTokenBalance(curToken, wallet)
            dispatchedTokenBalances[curToken] = tokenBal
        }
        dispatch(setTokenBalances(dispatchedTokenBalances))
        
    }

    useEffect(() => {
        if (mode == "Token") getRecentBets()
        if (wallet.publicKey) getTokenBalances()
    }, [betMultiplier, betAmount, selectedToken, wallet])

    useEffect(() => {
        if (walletConnected) dispatch(setAccordionActiveKey("1"));
    }, [walletConnected])


    const setLost = async () => {
        setLoaderImage("images/lost.gif")
        setGameState("lost")
        dispatch(setLoading("lost"))
        if (sound) playLoss()
        let msg = "YOU LOST A " + betMultiplier + "X BET WITH " + betAmount + " " + selectedToken+"."
        setLoaderMsg(msg)
    }

    const tokens = Object.keys(TOKENS).map((key, index) => {
        let token = key
        if (tokenBalances[key] > 0){
            return (
                <Dropdown.Item key={index+1} eventKey={key}>
                    <h5 style={{ marginBottom: 0 }}>
                        <img alt="not found"
                            src={`images/${token}.png`}
                            width={20}
                            style={{
                                top: "-2px",
                                position: "relative",
                                marginRight: 5,
                            }}
                        />
                        {key} <span style={{float: "right"}}>{tokenBalances[key]}</span>
                    </h5>
                </Dropdown.Item>
            )            
        }

    })

    const setWon = async () => {
        setLoaderImage("images/won.gif")
        setGameState("won")
        dispatch(setLoading("won"))
        if (sound) playWin()
        let betWin = betMultiplier * betAmount
        betWin = Math.floor(betWin)
        let msg = "YOU WON " + betWin + " ON A " + betMultiplier + "X BET!!!"
        setLoaderMsg(msg)
    }


    const selectToken = async (token: any) => {
        dispatch(setToken(token))
        let tokenBal = await getTokenBalance(token, wallet)
        setCurrentTokenBalance(tokenBal)
    }

    const play = async () => {
        await getTokenBalances()
        dispatch(setAccordionActiveKey("1"))
        if (tokenBalances[selectedToken] < betAmount * 1.1) {
            setLoaderImage("images/notenoughsol.gif")
            setLoaderMsg(`YOU DO NOT HAVE ENOUGH ${selectedToken} TO PLAY`)
            setGameState("not enough sol")
            setLoaderActive(true)
        } else {
            dispatch(setLoading("loading"))
            setGameState("playing")
            setLoaderImage("images/trident1.gif")
            let msg =
                "Playing " + betMultiplier + "x bet with " + betAmount + " " + selectedToken+"."
            setLoaderMsg(msg)
            setLoaderActive(true)
            // setTimeout(() => setWon(), 3000)
            try {
                const data = await playTokenBet(
                    betAmount,
                    betMultiplier,
                    selectedToken,
                    wallet,
                    dispatch,
                    setBetAmount,
                    setBetMultiplier,
                    setLoaderMsg,
                    setGameState,
                    setLoaderImage,
                )
                // setLoaderActive(false)
                if (data.status =="success") {
                    if (data.won) {                        
                        let mixData = {
                            amount: data.amount,
                            multiplier: data.multiplier,
                            won: data.won,
                            coin: selectedToken,
                            ...playerDetails,
                        }
                        console.log("logging", JSON.stringify(mixData))
                        mixpanel.track("event name", mixData)
                        await setWon()
                    } else {
                        let mixData = {
                            amount: data.amount,
                            multiplier: data.multiplier,
                            won: data.won,
                            coin: selectedToken,
                            ...playerDetails,
                        }
                        console.log("logging", JSON.stringify(mixData))
                        mixpanel.track("event name", mixData)
                        await setLost()
                    }
                    getRecentBets()
                } else if (data.status =="cancelled") {
                    setLoaderActive(false)
                } else if (
                    data.status =="error encountered" ||
                    data.status =="paused game"
                ) {
                    // console.log(data)
                    setGameState(data.status)
                    setLoaderImage(data.loaderImg)
                    setLoaderMsg(data.msg)
                    setSubMsgs(data.subMsgs)
                }
            } catch (err) {
                console.log(err)
                setGameState("error encountered")
                setLoaderImage("images/networkcongestion.gif")
                setLoaderMsg("Solami Rugged")
                setSubMsgs([
                    "An error occurred in the network",
                    "Please check solscan or solana explorer to see if you won",
                    "If the bet has not completed, you can retry for free.",
                ])
            }
        }
    }
    const playAgainButtonClick = () => {
        setLoaderActive(false)
        setGameState("not playing")
    }
    // console.log(selectedToken, "=", betAmount, betMultiplier)
    let betButtonMsg = "PLAY"
    let betOutput = betAmount * betMultiplier
    betOutput = Math.floor(betOutput)
    if (betAmount * betMultiplier !== 0) betButtonMsg = "PLAY TO WIN " + betOutput + " " + selectedToken
    let loaderDiv = (
        <div className='col-md-12'>
            <img alt="not found" src={loaderImage} style={{ width: "50%" }} />
            <h4 style={{ color: "black" }}>{loaderMsg}</h4>
            {loaderImage =="images/won.gif" ||
            loaderImage =="images/lost.gif" ? (
                <Button
                    variant='outline-dark'
                    style={{ marginTop: 20 }}
                    onClick={() => playAgainButtonClick()}
                >
                    <h3>Play Again</h3>
                </Button>
            ) : null}
        </div>
    )
    if (gameState =="won") {
        loaderDiv = (
            <div className='col-md-12'>
                <img alt="not found" src={loaderImage} style={{ width: "50%" }} />
                <h4 style={{ color: "black" }}>{betMultiplier}X YOU WON!</h4>
                <h4 style={{ color: "green", fontWeight: "bold" }}>
                    +{betAmount * betMultiplier} {selectedToken}
                </h4>
                {loaderImage =="images/won.gif" ||
                loaderImage =="images/lost.gif" ? (
                    <Button
                        variant='outline-dark'
                        style={{ marginTop: 20 }}
                        onClick={() => playAgainButtonClick()}
                    >
                        <h3>Play Again</h3>
                    </Button>
                ) : null}
            </div>
        )
    } else if (gameState =="lost") {
        loaderDiv = (
            <div className='col-md-12'>
                <img alt="not found" src={loaderImage} style={{ width: "50%" }} />
                <h4 style={{ color: "black" }}>YOU LOST</h4>
                <h4 style={{ color: "red" }}>{betAmount} {selectedToken}</h4>
                {loaderImage =="images/won.gif" ||
                loaderImage =="images/lost.gif" ? (
                    <Button
                        variant='outline-dark'
                        style={{ marginTop: 20 }}
                        onClick={() => playAgainButtonClick()}
                    >
                        <h3>Play Again</h3>
                    </Button>
                ) : null}
            </div>
        )
    } else if (gameState =="error encountered") {
        let subMsgArr = subMsgs.map((subMsg, i) => (
            <h5 style={{ color: "#2a2a2a" }} key={i + 1}>
                {subMsg}
            </h5>
        ))
        loaderDiv = (
            <div className='col-md-12'>
                <img alt="not found" src={loaderImage} style={{ width: "50%" }} />
                <h4 style={{ color: "black" }}>{loaderMsg}</h4>
                {subMsgArr}
                <Button
                    variant='outline-dark'
                    style={{ marginTop: 20 }}
                    onClick={() => playAgainButtonClick()}
                >
                    <h3>Retry</h3>
                </Button>
            </div>
        )
    } else if (gameState =="paused game") {
        let subMsgArr = subMsgs.map((subMsg, i) => (
            <h5 style={{ color: "#2a2a2a" }} key={i + 1}>
                {subMsg}
            </h5>
        ))
        loaderDiv = (
            <div className='col-md-12'>
                <img alt="not found" src={loaderImage} style={{ width: "50%" }} />
                <h4 style={{ color: "black" }}>{loaderMsg}</h4>
                {subMsgArr}
                <Button
                    variant='outline-dark'
                    style={{ marginTop: 20 }}
                    onClick={() => play()}
                >
                    <h3>Retry</h3>
                </Button>
            </div>
        )
    } else if (gameState =="not enough sol") {
        loaderDiv = (
            <div className='col-md-12'>
                <img alt="not found" src={loaderImage} style={{ width: "50%" }} />
                <h4 style={{ color: "black" }}>{loaderMsg}</h4>
                <Button
                    variant='outline-dark'
                    style={{ marginTop: 20 }}
                    onClick={() => playAgainButtonClick()}
                >
                    <h3>Play</h3>
                </Button>
            </div>
        )
    }

    return (
        <Container>
            <LoadingOverlay
                active={loaderActive}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        background: "rgba(255, 255, 255, 0.9)",
                        height: "100%!important",
                    }),
                }}
                spinner={<div className='container-fluid'>{loaderDiv}</div>}
            >
                <Container style={{ paddingLeft: "5%", paddingRight: "5%" }}>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                    <Col style={{marginBottom: 30}}>

                    </Col>
                    </Row>
                    {walletConnected ? (
                        <div>
                            <Row style={{ paddingBottom: 40, justifyContent: 'center'  }}>
                                    <TokenSelect/>
                                
                            </Row>
                           <Multipliers/>
                            <Row style={{ paddingBottom: 20, paddingTop: 20 }}>
                                <h3 style={{color: "white"}}>FOR</h3>
                            </Row>
                            <Row style={{paddingBottom: 20, display: 'flex', justifyContent: 'center'}}>
                                <Amounts/>
                            </Row>
                            <Row style={{ paddingBottom: 20, paddingTop: 20 }}>
                                <Col>
                                    <Button
                                        disabled={
                                            walletConnected ==null ||
                                            betAmount ==0 ||
                                            betMultiplier ==0
                                        }
                                        variant='light'
                                        style={{ width: "100%" }}
                                        onClick={() => play()}
                                    >
                                        <h2 style={{}}>{betButtonMsg}</h2>
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    ) : (
                        <Container>
                            <WalletModalProvider>
                                <WalletMultiButton style={{ margin: "auto" }} />
                            </WalletModalProvider>
                        </Container>
                    )}
                </Container>
                <RecentPlays />
                <div
                    style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: 40,
                        color: 'white'
                    }}
                >
                    <a
                        href='javascript:void(0)'
                        style={{color: "white"}}
                        onClick={() => {
                            // console.log("MODALING");
                            dispatch(setShowFaq(true))
                        }}
                    >
                        <h4>FAQ</h4>
                    </a>
                </div>
                <FAQ />
                <br/><br/>
            </LoadingOverlay>
        </Container>
    )
}

export default Token
